import { atom } from 'recoil';
import { WIZARD_SCREEN_TYPES } from './shared/constants/stringConstants';

export const exitModalState = atom({
  key: 'exitModalState',
  default: false,
});

export const currentLeaseRenewalWizardScreenState = atom<WIZARD_SCREEN_TYPES>({
  key: 'currentLeaseRenewalWizardScreenState',
  default: WIZARD_SCREEN_TYPES.WHAT_TO_DO_WHEN_A_LEASE_IS_ENDING,
});

export const isSigningCompleteModalOpenState = atom({
  key: 'isSigningCompleteModalOpenState',
  default: false,
});

export const isEditLeaseExtensionModalOpenState = atom({
  key: 'isEditLeaseExtensionModalOpenState',
  default: false,
});

export const renewalProposalMessageState = atom({
  key: 'renewalProposalMessageState',
  default: '',
});
